import React from 'react';
import { DetailGridInfo } from 'ag-grid-community';

export type GridContextType = {
    grid: DetailGridInfo | null;
};

export const GridContext = React.createContext<GridContextType>({ grid: null });
